import type { FC } from 'react';
import React from 'react';
import { Box } from '@edreamsodigeo/prisma-design-system';

const FlightSummaryContainer: FC = ({ children }) => (
  <Box
    mb={{ _: '0', md: 'big' }}
    backgroundColor={{ _: 'neutral.0', md: 'inherit' }}
  >
    {children}
  </Box>
);

export default FlightSummaryContainer;
